import { AxiosResponse } from 'axios';
import { backendApiInstance } from './backendApiInstance';

export async function getPaymentByOrganizationId(organizationId: string): Promise<AxiosResponse> {
  return backendApiInstance.get(`/payments/organization/${organizationId}`);
}
